const torrentProperties = {
  dateAdded: {
    id: 'torrents.properties.date.added',
    defaultMessage: 'Date Added'
  },
  downRate: {
    id: 'torrents.properties.download.speed',
    defaultMessage: 'Download Speed'
  },
  downTotal: {
    id: 'torrents.properties.download.total',
    defaultMessage: 'Downloaded'
  },
  eta: {
    id: 'torrents.properties.eta',
    defaultMessage: 'ETA'
  },
  name: {
    id: 'torrents.properties.name',
    defaultMessage: 'Name'
  },
  peers: {
    id: 'torrents.properties.peers',
    defaultMessage: 'Peers'
  },
  percentComplete: {
    id: 'torrents.properties.percentage',
    defaultMessage: 'Percent Complete'
  },
  ratio: {
    id: 'torrents.properties.ratio',
    defaultMessage: 'Ratio'
  },
  seeds: {
    id: 'torrents.properties.seeds',
    defaultMessage: 'Seeds'
  },
  sizeBytes: {
    id: 'torrents.properties.size',
    defaultMessage: 'File Size'
  },
  tags: {
    id: 'torrents.properties.tags',
    defaultMessage: 'Tags'
  },
  upRate: {
    id: 'torrents.properties.upload.speed',
    defaultMessage: 'Upload Speed'
  },
  upTotal: {
    id: 'torrents.properties.upload.total',
    defaultMessage: 'Uploaded'
  },
  dateCreated: {
    id: 'torrents.properties.creation.date',
    defaultMessage: 'Creation Date'
  },
  basePath: {
    id: 'torrents.properties.base.path',
    defaultMessage: 'Base Path'
  },
  ignoreScheduler: {
    id: 'torrents.properties.ignore.schedule',
    defaultMessage: 'Ignore Scheduler'
  },
  comment: {
    id: 'torrents.properties.comment',
    defaultMessage: 'Comment'
  },
  hash: {
    id: 'torrents.properties.hash',
    defaultMessage: 'Hash'
  },
  isPrivate: {
    id: 'torrents.properties.is.private',
    defaultMessage: 'Private'
  },
  message: {
    id: 'torrents.properties.tracker.message',
    defaultMessage: 'Tracker Message'
  },
  trackerURIs: {
    id: 'torrents.properties.trackers',
    defaultMessage: 'Trackers'
  }
};

export default torrentProperties;



// WEBPACK FOOTER //
// ./client/src/javascript/constants/TorrentProperties.js